import { IAppointmentBase } from '../../models/appointments';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

export interface ICreateAppointmentProduct {
  costCenter: string;
  description?: string;
  finishAt?: string;
  name: string;
  price: number;
  productCode: string;
  productId: string;
  productNature: string;
  productType: string;
  invoiceType: 'NF' | 'ND';
  quantity: number;
  startAt?: string;
}

interface ICreateAppointment {
  userId: string;
  products: ICreateAppointmentProduct[];
  description?: string;
}

export type INewAppointment = IAppointmentBase;

export const createAppointmentsService = async ({
  userId,
  products,
  description,
}: ICreateAppointment): Promise<INewAppointment> => {
  const { data } = await jhsfBookingsApi.post<INewAppointment>(
    '/appointments',
    {
      userId,
      products,
      description,
    },
  );

  return data;
};
